import React from 'react'
import { Link, NavLink, Route } from 'react-router-dom'
import { Redirect } from 'react-router'
import Converting from './blog/converting.jsx'
import Test from './blog/test.jsx'

class Blog extends React.Component {

    render = () => {
        return (
            <article id="blogContainer" className="solo">

                <h1 className="nostyle"><i className="fa fa-pen-alt"><span>Scott's blog</span></i></h1>

                <div id="blogLayout">
                    <div id="blogMenu">
                        <ul>
                            <li><NavLink to="/blog/converting-my-single-page-app-to-react">Converting my app to ReactJS: One man's journey</NavLink></li>
                            <li><NavLink to="/blog/why-you-might-not-need-a-blog">Why you might not need a blog</NavLink></li>
                        </ul>
                    </div>
                    <div id="blogMain">
                        <div>
                            <Route path={`${this.props.match.path}/converting-my-single-page-app-to-react`} component={Converting}></Route>
                            <Route path={`${this.props.match.path}/why-you-might-not-need-a-blog`} component={Test}></Route>
                            <Route exact path="/blog" render = {() => {
                                
                                if(/id=([\w+-])+/.test(document.location.search)){
                                    var id = document.location.search.match(/id=([\w-]+)/)[1]
                                    return <Redirect to={`/blog/${id}`}></Redirect>
                                   
                                  } else {
                                    return this.DefaultBlog()
                                  }
                               
                            }}></Route>
                        </div>
                    </div>

                </div>
            </article>
        )
    }

    DefaultBlog = () => {
        
        return( 
            <article>
                
                <blockquote>In a time of universal deceit - telling the truth is a revolutionary act. (unknown)</blockquote>  
            
            </article>
        )
    }
    
}
export default Blog